import { CloudWatchLogsClient } from "@aws-sdk/client-cloudwatch-logs";

import { config } from "dotenv";

config();

// Set the AWS Region.
const REGION = process.env?.VUE_APP_AWS_REGION ? process.env.VUE_APP_AWS_REGION : "ap-northeast-1";
// Create an Amazon CloudWatch service client object.
export const cwlClient = new CloudWatchLogsClient({
  region: REGION,
  credentials: {
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID as string,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY as string,
  },
});
